var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKingmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 16,
    viewBox: "0 0 82 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 81.1936,
    height: 15,
    rx: 7.5,
    fill: "#FF0003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.67742L16.5 4V7.32258L12.5 9.51613L8.5 7.32258V4L10.4677 5.67742L12.5 4L14.5 5.67742Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.8065V7.64516L13.2419 9.3871L16.5 11.8065Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9839 9.51613L16.2419 12H8.69355L11.9839 9.51613L12.5 9.80645L12.9839 9.51613Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6935 9.3871L8.5 7.64516V11.8065L11.6935 9.3871Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8964 12.5H24.093L22.6974 9.2643L22.3516 9.8571V12.5H19.7828V3.54625H22.3516V7.0907L23.8707 3.54625H26.7606L24.3276 7.4612L26.8964 12.5ZM27.4424 3.54625H30.0483V12.5H27.4424V3.54625ZM31.2886 3.54625H33.1905L35.5123 7.4118H35.537V3.54625H37.8218V12.5H36.0434L33.5981 8.3751H33.5734V12.5H31.2886V3.54625ZM42.2057 3.42275C43.8112 3.42275 45.0092 4.26255 45.3303 5.67045L43.4407 6.31265C43.1814 5.6581 42.8479 5.4605 42.4157 5.4605C41.6747 5.4605 41.3659 5.84335 41.3659 6.8437V9.3137C41.3659 10.2276 41.7488 10.5734 42.3786 10.5734C42.675 10.5734 42.885 10.4869 43.0702 10.2646V9.2643H42.3539V7.67115H45.3179V12.5H43.2308V12.1048C42.8109 12.4506 42.2551 12.6235 41.6376 12.6235C39.9827 12.6235 38.7601 11.6108 38.7601 9.35075V6.83135C38.7601 4.75655 39.8592 3.42275 42.2057 3.42275ZM52.626 3.54625H55.1084V12.5H52.7495V8.3504H52.7248L51.2922 11.3514H50.156L48.7358 8.36275H48.7111V12.5H46.3522V3.54625H48.8346L50.7118 8.2022H50.7365L52.626 3.54625ZM58.5872 10.9315L58.2908 12.5H55.6726L58.0315 3.54625H61.0325L63.3914 12.5H60.7485L60.4397 10.9315H58.5872ZM59.4888 5.91745L58.933 9.1408H60.0816L59.5135 5.91745H59.4888ZM64.01 3.54625H66.6159V12.5H64.01V3.54625ZM67.8562 3.54625H70.3756V10.3387H72.9938V12.5H67.8562V3.54625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingmail);
export default __webpack_public_path__ + "static/media/kingmail.43397655760f122175280f9c078ae5a0.svg";
export { ForwardRef as ReactComponent };